import { gql } from "@apollo/client";

export const GET_FRECUENCIAS_DISPONIBLES = gql`
query GetFrecuenciasDisponibles($idFrecuenciaPlan: Int!) {
    frecuenciasDisponibles(idFrecuenciaPlan: $idFrecuenciaPlan) {
            idFrecuenciaProfesional
            descripccion
            descripcionpp
            frecuencia
            guardia
      }
}`;